<template>
  <div class="this-page">
    <template>
      <toolBar :package="package" from="order" useSearch @chooseTime="chooseTime" @clear="clearSearch"
               @directionSelect="directionSelect" @search="searchOrder" @select="selectStatus"
               @selectPackage="selectPackage"/>
    </template>
    <template>
      <el-table :data="orders" :fit="true" :height="tableHeight" size="small" stripe style="width: 100%;"
                @selection-change="changeCheck">
        <!--<el-table-column prop="id" label="内部编号" width="70">
        </el-table-column>-->
        <el-table-column fixed type="selection" width="60">
        </el-table-column>
        <el-table-column fixed label="会员号" prop="uid" width="80">
        </el-table-column>
        <el-table-column fixed label="货柜" prop="containerId" width="80">
          <template slot-scope="scope">
            <span>{{ getMatch(scope.row.containerId) }}</span>
          </template>
        </el-table-column>
        <el-table-column fixed label="运单号" prop="no" width="150">
        </el-table-column>
        <el-table-column label="寄件人" prop="poster" width="120">
          <template slot-scope="scope">
            <el-tooltip placement="right">
              <div slot="content">
                <template>{{ scope.row.posterDetail }}</template>
              </div>
              <el-button size="small" type="text">{{ scope.row.poster }}</el-button>
            </el-tooltip>


          </template>
        </el-table-column>
        <el-table-column label="收件人" prop="receiver" width="120">
          <template slot-scope="scope">
            <el-tooltip placement="right">
              <div slot="content">
                <template>{{ scope.row.receiverDetail }}</template>
              </div>
              <el-button size="small" type="text">{{ scope.row.receiver }}</el-button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="寄件方式" prop="type" width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.method == 1" size="small" type="success">网点自寄</el-tag>
            <el-tag v-if="scope.row.method == 2" size="small" type="warning">上门取件</el-tag>
            <el-tag v-if="scope.row.method == 0" size="small" type="danger">系统空单</el-tag>
            <el-tag v-if="scope.row.method == 4" size="small" type="danger">集运拼团</el-tag>
            <el-tag v-if="scope.row.method == 3" size="small">集运打包</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="计费方式" prop="type" width="90">
          <template slot-scope="scope">
            {{ scope.row.priceMethod == 1 ? '整单' : '' }}
            {{ scope.row.priceMethod == 2 ? '重量' : '' }}
            {{ scope.row.priceMethod == 3 ? '体积' : '' }}
          </template>
        </el-table-column>

        <el-table-column label="寄托物" prop="type" width="100">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="showPackages(scope.row.no)">{{ scope.row.items.length }}项
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="总重量" prop="type" width="100">
          <template slot-scope="scope">
            {{ scope.row.weight }} KG
          </template>
        </el-table-column>
        <el-table-column label="总体积" prop="type" width="100">
          <template slot-scope="scope">
            {{ scope.row.volume }} 立方
          </template>
        </el-table-column>
        <el-table-column label="实际体积" prop="type" width="100">
          <template slot-scope="scope">
            {{ scope.row.realVolume }} 立方
          </template>
        </el-table-column>
        <el-table-column label="合包数量" prop="type" width="100">
          <template slot-scope="scope">
            {{ scope.row.mergePackage }}
          </template>
        </el-table-column>
        <el-table-column label="出库照片" prop="type" width="100">
          <template slot-scope="scope">
            <el-image
                v-if="scope.row.outboundAlbum "
                :preview-src-list="scope.row.outboundAlbum"
                :src="scope.row.outboundAlbum[0]"
                style="width: 60px; height: 60px">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="下单时间" prop="created" width="160">
        </el-table-column>
        <el-table-column label="运输线路" prop="route" width="140">
        </el-table-column>
        <el-table-column label="轨迹状态" prop="location" width="140">
          <template slot-scope="scope">
            {{ scope.row.lastProgress ? scope.row.lastProgress.title : '无' }}
          </template>
        </el-table-column>
        <el-table-column label="客户备注" min-width="100" prop="userRemark">

        </el-table-column>
        <el-table-column label="内部备注" min-width="100" prop="sysRemark">
          <template slot-scope="scope">
            <el-button type="text"
                       @click="openRemark(scope.row.id,scope.row.sysRemark === '-'?'':scope.row.sysRemark)">
              <i class="el-icon-edit"></i></el-button>
            {{ scope.row.sysRemark || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="运单总价" prop="price" width="100">
        </el-table-column>
        <el-table-column label="运单状态" prop="type" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == -1" size="small" type="info">已取消</el-tag>
            <el-tag v-if="scope.row.status == 0" size="small" type="warning">待收件</el-tag>
            <el-tag v-if="scope.row.status == 1" size="small" type="warning">待打包</el-tag>
            <el-tag v-if="scope.row.status == 2" size="small" type="danger">待支付</el-tag>
            <el-tag v-if="scope.row.status == 3" size="small" type="warning">待出库</el-tag>
            <el-tag v-if="scope.row.status == 4" size="small" type="success">运输中</el-tag>
            <el-tag v-if="scope.row.status == 5" size="small" type="success">转投成功</el-tag>
            <el-tag v-if="scope.row.status == 6" size="small" type="success">派件</el-tag>
            <el-tag v-if="scope.row.status == 7" size="small" type="success">妥投</el-tag>
            <el-tag v-if="scope.row.status == 8" size="small" type="info">存库</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Printer" prop="type" width="120">
          <template slot-scope="scope">
            <el-button v-if="scope.row.method != 4" icon="el-icon-printer" size="small"
                       @click="singlePrint(scope.row.id)">Print
            </el-button>
            <el-button v-if="scope.row.method == 4" icon="el-icon-printer" size="small"
                       @click="groupPrint(scope.row.id)">Print
            </el-button>

          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" prop="type" width="180">
          <template slot-scope="scope">
            <el-button-group v-if="scope.row.status == 0">

              <el-button icon="el-icon-takeaway-box" size="mini" type="primary" @click="pickup(scope.row.id)">收件
              </el-button>
              <el-button icon="el-icon-circle-close" size="mini" type="danger"
                         @click="cancelOrder(scope.row.id,scope.row.method,scope.row.uid)">取消
              </el-button>
            </el-button-group>
            <el-button-group v-if="scope.row.status == 1">

              <el-button icon="el-icon-folder-checked" size="mini" type="primary" @click="showPack(scope.row)">打包
              </el-button>
              <el-button icon="el-icon-circle-close" size="mini" type="danger"
                         @click="cancelOrder(scope.row.id,scope.row.method,scope.row.uid)">取消
              </el-button>
            </el-button-group>
            <el-button-group v-if="scope.row.status == 2">

              <el-button icon="el-icon-circle-check" size="mini" type="success" @click="offlinePay(scope.row.id)">线下付
              </el-button>
              <el-button icon="el-icon-circle-close" size="mini" type="danger"
                         @click="cancelOrder(scope.row.id,scope.row.method,scope.row.uid)">取消
              </el-button>
            </el-button-group>


            <el-button v-if="scope.row.status == 3" icon="el-icon-circle-check" size="mini" type="success"
                       @click="sendOut(scope.row.id)">出库
            </el-button>

            <el-button v-if="scope.row.status == 4 && scope.row.expressStatusId < 6" icon="el-icon-position"
                       size="mini"
                       type="primary"
                       @click="showProgress(scope.row.id)">轨迹
            </el-button>
            <el-button v-if="scope.row.status == 4 && scope.row.expressStatusId == 6 &&scope.row.method < 3 "
                       icon="el-icon-finished" size="mini" type="success"
                       @click="transDeliver(scope.row.id)">转投
            </el-button>
            <el-button v-if="scope.row.status == 4 && scope.row.expressStatusId == 6 &&scope.row.method == 3"
                       icon="el-icon-finished" size="mini" type="success"
                       @click="sendHome(scope.row.id,scope.row.uid)">送货
            </el-button>
            <el-button v-if="scope.row.status == 4 && scope.row.expressStatusId == 6 &&scope.row.method == 3"
                       icon="el-icon-finished" size="mini" type="success"
                       @click="selfPick(scope.row.id,scope.row.uid)">自提
            </el-button>
            <el-button v-if="scope.row.status == 6" icon="el-icon-finished" size="mini"
                       type="success" @click="signExpress(scope.row.id,scope.row.uid)">确认签收
            </el-button>
            <el-button v-if="scope.row.status == 4 && scope.row.expressStatusId == 6 &&scope.row.method == 4 "
                       icon="el-icon-finished" size="mini" type="success"
                       @click="signGroup(scope.row.id,scope.row.uid)">拼团妥投
            </el-button>

            <el-button-group v-if="scope.row.status == 4">
              <!--<el-button type="success" icon="el-icon-circle-check" @click="cancelOrder(scope.row.id)">结束</el-button>-->
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <template>
        <div style="display: flex;align-items: center;">
          <el-button :disabled="!(checkList.length>0)" style="margin-top:20px" @click="addPackage">添加到货柜({{
              checkList.length
            }})
          </el-button>
          <el-pagination :current-page="page" :page-count="pageCount" background layout="prev, pager, next"
                         style="margin-top:20px" @current-change="pageChange">
          </el-pagination>
        </div>

      </template>
    </template>
    <template>
      <el-dialog :before-close="handlePackClose" :title="packForm.method == 3?'集运打包计费':'打包计费'" :visible.sync="packShow"
                 width="700px">
        <el-form :inline="true" :model="packForm" style="max-width: 700px;">
          <el-form-item :label-width="formLabelWidth" label="保价金额">
            <el-input v-model="packForm.insure" autocomplete="off" tyle="number"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="保价费用">
            <el-input v-model="packForm.price.insure" autocomplete="off" tyle="number"></el-input>
          </el-form-item>
          <el-form-item v-if="packForm.method != 3" :label-width="formLabelWidth" label="取件费用">
            <el-input v-model="packForm.price.pickup" autocomplete="off" tyle="number"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="打包费用">
            <el-input v-model="packForm.price.pack" autocomplete="off" tyle="number"></el-input>
          </el-form-item>
          <el-form-item v-if="packForm.method == 3" :label-width="formLabelWidth" label="包装方式">
            {{ packForm.packMethod == 1 ? '简易包装' : '' }}
            {{ packForm.packMethod == 2 ? '木架包装' : '' }}
            {{ packForm.packMethod == 3 ? '纸箱包装' : '' }}
            {{ packForm.packMethod == 4 ? '气泡棉包装' : '' }}
          </el-form-item>
          <el-form-item v-if="packForm.method == 3" :label-width="formLabelWidth" label="上门送货费用">
            <el-input v-model="packForm.price.sendPrice" autocomplete="off" tyle="number"></el-input>
          </el-form-item>
          <el-form-item v-if="packForm.method == 3" :label-width="formLabelWidth" label="收货方式">
            {{ packForm.price.sendPrice > 0 ? '送货到家' : '自提' }}
          </el-form-item>
          <el-form-item v-if="packForm.method != 3" :label-width="formLabelWidth" label="预约纸箱">
            <el-input v-model="packForm.box" autocomplete="off" tyle="number"></el-input>
          </el-form-item>
          <el-form-item v-if="packForm.method != 3" :label-width="formLabelWidth" label="纸箱计费">
            <el-input v-model="packForm.price.box" autocomplete="off" tyle="number"></el-input>
          </el-form-item>
          <el-form-item v-if="packForm.method == 3" :label-width="formLabelWidth" label="GST">
            <el-input v-model="packForm.price.gst" autocomplete="off" tyle="number"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="其他费用">
            <el-input v-model="packForm.price.other" autocomplete="off" tyle="number"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="运费规则">
            <el-select v-model="packForm.priceMethod" placeholder="请选择计费规则" style="width: 178px;">
              <el-option label="整单计费" value="1"></el-option>
              <el-option label="重量计费" value="2"></el-option>
              <el-option label="体积计费" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="packForm.priceMethod == '1'" :label-width="formLabelWidth" label="整单运费">
            <el-input v-model="packForm.price.express" autocomplete="off" type="number"></el-input>
          </el-form-item>
          <el-form-item v-if="packForm.priceMethod == '2'" :label-width="formLabelWidth" label="重量运费">
            <el-input v-model="packForm.price.express" autocomplete="off" type="number"></el-input>
          </el-form-item>
          <el-form-item v-if="packForm.priceMethod == '2'" :label-width="formLabelWidth" label="总重量(kg)">
            <el-input v-model="packForm.weight" autocomplete="off" type="number"></el-input>
          </el-form-item>
          <el-form-item v-if="packForm.priceMethod == '3'" :label-width="formLabelWidth" label="体积运费">
            <el-input v-model="packForm.price.express" autocomplete="off" type="number"></el-input>
          </el-form-item>
          <el-form-item v-if="packForm.priceMethod == '3'" :label-width="formLabelWidth" label="总体积">
            <el-input v-model="packForm.volume" autocomplete="off" type="number"></el-input>
          </el-form-item>
          <el-form-item v-if="packForm.priceMethod" :label-width="formLabelWidth" label="账单费用">
            <el-input v-model="packForm.price.total" autocomplete="off" type="number"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button v-if="packForm.priceMethod" @click="calcPackPrice()">自动计算合计费用</el-button>
          <el-button @click="cancelPack()">取 消</el-button>
          <el-button type="primary" @click="confirmPack()">确 定</el-button>
        </div>
      </el-dialog>
    </template>
    <template>
      <el-dialog :visible.sync="sendShow" title="订单出库">
        <el-form>

          <el-form-item :label-width="formLabelWidth" label="运输路线">
            <el-select v-model="sendRoute" placeholder="请选择运输路线">
              <el-option label="新中海运" value="1"></el-option>
              <el-option label="新中空运" value="2"></el-option>
              <el-option label="新中经济空运" value="5"></el-option>
              <el-option label="中新集运海运" value="3"></el-option>
              <el-option label="中新集运空运" value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="sendShow = false">取 消</el-button>
          <el-button type="primary" @click="confirmSend()">确 定</el-button>
        </div>
      </el-dialog>
    </template>
    <template>
      <el-dialog :visible.sync="progressShow" title="运单轨迹">
        <el-table :data="progressResult">
          <el-table-column label="标题" property="title"></el-table-column>
          <el-table-column label="描述" property="description"></el-table-column>
          <!-- <el-table-column property="created" label="时间" width="160"></el-table-column>-->
          <el-table-column label="时间" property="created" width="250">
            <template slot-scope="scope">
              <el-date-picker v-model="progressResult[scope.$index].created" :clearable="false"
                              placeholder="自定义时间"
                              type="datetime"
                              value-format="yyyy/MM/dd HH:mm:ss"
                              @blur="noUpdate"
                              @change="updateProgressTime(progressResult[scope.$index].created,progressResult[scope.$index].id)">
              </el-date-picker>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="progressShow = false">取 消</el-button>
          <el-button type="danger" @click="transBackOrder()">物流回溯</el-button>
          <el-button type="primary" @click="transOrder()">自动流转</el-button>
        </div>
      </el-dialog>
    </template>
    <template>
      <el-dialog :visible.sync="transDeliverShow" title="转投国内快递" width="500px">
        <el-form>
          <el-form-item :label-width="formLabelWidth" label="国内快递单号">
            <el-input v-model="transDeliverNo" placeholder="请输入国内快递主单号"></el-input>
          </el-form-item>
          <el-form-item :label-width="formLabelWidth" label="快递转投备注">
            <el-input v-model="transDeliverNote" placeholder="请输入国内快递转投备注" type="textarea"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="transDeliverShow = false">取 消</el-button>
          <el-button type="primary" @click="confirmTransDeliver()">确 定</el-button>
        </div>
      </el-dialog>
    </template>
    <template>
      <el-dialog v-if="packages.length > 0" :visible.sync="packagesShow" title="运单明细">
        <el-table :data="packages">
          <el-table-column v-if="packages[0].uid" label="会员号" property="uid"></el-table-column>
          <el-table-column label="品名" property="package_mark">
            <template slot-scope="scope">
              {{ scope.row.name || scope.row.package_mark }}
            </template>
          </el-table-column>
          <el-table-column label="单号" property="item_number">
            <template slot-scope="scope">
              {{ scope.row.express_no || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="数量" property="item_number">
            <template slot-scope="scope">
              {{ scope.row.number || scope.row.item_number }}
            </template>
          </el-table-column>
          <el-table-column label="总价" property="total_price">
            <template slot-scope="scope">
              {{ scope.row.total_price / 100 }}
            </template>
          </el-table-column>


          <el-table-column label="GST" property="gst">
            <template slot-scope="scope">
              {{ (scope.row.total_price / 100 * 0.07).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column v-if="packages[0].check_pic" label="入库照片" property="check_pic" width="100px">
            <template slot-scope="scope">
              <el-image
                  :preview-src-list="scope.row.check_pic ? [scope.row.check_pic]:[]"
                  :src="scope.row.check_pic || '无'"
                  fit="cover"
                  style="width: 60px; height: 60px">
              </el-image>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="packagesShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </template>

    <template>
      <el-dialog :visible.sync="groupShow" title="团成员单打印">
        <el-table :data="groupMember">
          <el-table-column label="会员号" property="uid"></el-table-column>

          <el-table-column label="操作" property="gst">
            <template slot-scope="scope">
              <el-button icon="el-icon-printer" size="small" @click="groupPrintData(scope.row.uid,groupId,groupOrder)">
                Print
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
          <el-button @click="groupShow = false">取 消</el-button>
        </div>
      </el-dialog>
    </template>
    <el-dialog :visible.sync="dialogFormVisible" title="选择货柜">

      <el-select v-model="packageId2" clearable placeholder="货柜筛选" @change="selectPackage2">
        <el-option
            v-for="item in package"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import toolBar from '../../components/tool-bar/index.vue'

export default {
  components: {
    toolBar
  },
  data() {
    return {
      dialogFormVisible: false,
      checkList: [],
      packageId: '',
      packageId2: '',
      tableHeight: document.documentElement.clientHeight - 165 + 'px',
      load: {
        orders: false
      },
      page: 1,
      searchValue: '',
      pageCount: 1,
      orders: [],
      packShow: false,
      formLabelWidth: '120px',
      packagesShow: false,
      packages: [],
      packForm: {
        uid: '',
        method: '',
        packMethod: '',
        id: '',
        box: 0,
        priceMethod: '',
        insure: 0,
        price: {
          other: 0,
          insure: 0,
          pickup: 0,
          pack: 0,
          box: 0,
          express: 0,
          total: 0,
          sendPrice: 0,
          gst: 0
        },
        weight: 0,
        volume: 0
      },
      sendShow: false,
      sendId: '',
      sendRoute: '',
      progressShow: false,
      progressId: '',
      progressResult: [],
      cusProgressTimeId: '',
      cusProgressTime: '',
      transDeliverShow: false,
      transDeliverId: '',
      transDeliverNo: '',
      transDeliverNote: '',
      groupShow: false,
      groupId: '',
      groupMember: [],
      groupOrder: '',
      status: "all",
      direction: 'all',
      date: [],
      package: [],
      match: ''
    }
  },
  mounted() {
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;

        that.tableHeight = window.fullHeight - 165 + 'px';  // 高

      })()
    };
    this.getOrders()
    this.getContainer()
  },
  methods: {
    getMatch(id) {
      let n = '未知';
      this.package.some(function (item, index) {
        if (item.id == id) {
          n = item.name
          return true
        }
      })
      return n
    },
    confirmAdd() {
      if (this.packageId2 == '') {
        this.$message('请选择货柜');
        return
      }
      this.$fetch.post('Container/join', {id: this.packageId2, list: this.checkList}).then(res => {
        this.page = 1
        this.dialogFormVisible = false
        this.getOrders()
      })
    },
    addPackage() {
      this.packageId2 = ''
      this.dialogFormVisible = true
    },
    changeCheck(e) {
      let a = []
      e.forEach(function (item, index) {
        a.push(item.id)
      })
      this.checkList = a
      console.log(this.checkList)
    },
    getContainer() {
      this.$fetch.post('Container/getList').then(res => {
        this.package = res
        console.log(this.package);

      })
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    selectStatus(v) {
      this.status = v || "all"

      this.page = 1
      this.getOrders()
    },
    selectPackage(e) {
      this.packageId = e
      this.page = 1
      this.getOrders()
    },
    selectPackage2(e) {
      this.packageId2 = e
    },
    directionSelect(v) {
      this.direction = v || 'all'
      this.page = 1
      this.getOrders()
    },
    chooseTime(t) {
      this.date = t
      this.page = 1
      this.getOrders()
    },
    getOrders() {
      this.$fetch.post('Order/getExpressOrder', {
        page: this.page,
        search: this.searchValue,
        status: this.status,
        direction: this.direction,
        date: this.date,
        container_id: this.packageId
      }, true).then(res => {
        this.load.orders = true
        this.orders = res.result
        this.pageCount = res.page
      })
    },
    cancelOrder(id, method, uid) {
      this.$fetch.post('Order/cancelExpressOrder', {
        id: id,
        method: method,
        uid: uid
      }, true).then(res => {
        this.getOrders()
      })
    },
    pickup(id) {
      this.$fetch.post('Order/pickupExpressOrder', {
        id: id
      }, true).then(res => {
        this.getOrders()
      })
    },
    offlinePay(id) {
      this.$fetch.post('Order/payExpressOrder', {
        id: id
      }, true).then(res => {
        this.getOrders()
      })
    },
    showPack(item) {
      this.packForm.uid = item.uid
      this.packForm.priceMethod = item.priceMethod || ''
      this.packForm.price.express = item.priceExpress || 0
      this.packForm.id = item.id
      this.packForm.method = item.method
      this.packForm.box = item.box
      this.packForm.price.box = item.box * 5
      this.packForm.insure = item.insure
      this.packForm.price.insure = item.priceInsure
      this.packForm.price.pack = item.pricePack || 0
      this.packForm.price.gst = item.gst || 0
      this.packForm.packMethod = item.packMethod
      this.packForm.price.sendPrice = item.sendPrice || 0
      this.packForm.price.total = item.priceTotal || 0
      this.packForm.weight = item.weight || 0
      this.packForm.volume = item.volume || 0
      this.packShow = true
    },
    handlePackClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
    },
    cancelPack() {
      this.packShow = false
    },
    calcPackPrice() {
      let price = 1 * this.packForm.price.box + 1 * this.packForm.price.insure + 1 * this.packForm.price.pack + 1 * this.packForm
          .price.pickup + 1 * this.packForm.price.other + 1 * this.packForm.price.express + this.packForm.price.sendPrice + this.packForm.price.gst
      this.packForm.price.total = price
    },
    confirmPack() {
      this.$fetch.post('Order/packExpressOrder', {
        pack: this.packForm
      }, true).then(res => {
        this.packShow = false
        this.getOrders()
      })
    },
    showPackages(no) {
      this.packages = []
      this.$fetch.post('Package/findOrderPackage', {
        no
      }, true).then(res => {
        this.packagesShow = true
        this.packages = res
      })
    },
    confirmSend() {
      this.$fetch.post('Order/sendExpressOrder', {
        id: this.sendId,
        route: this.sendRoute
      }, true).then(res => {
        this.sendShow = false
        this.getOrders()
      })
    },
    sendOut(id) {
      this.sendShow = true
      this.sendId = id
    },
    showProgress(id) {
      this.progressResult = []
      this.$fetch.post('Order/getExpressProgress', {
        id: id
      }, true).then(res => {
        this.progressShow = true
        this.progressId = id
        this.progressResult = res
      })
    },
    transBackOrder() {
      this.$fetch.post('Order/transBackExpressProgress', {
        id: this.progressId
      }, true).then(res => {
        this.getOrders()
        this.showProgress(this.progressId)
      })
    },
    transOrder() {
      this.$fetch.post('Order/transExpressProgress', {
        id: this.progressId
      }, true).then(res => {
        this.getOrders()
        this.showProgress(this.progressId)
      })
    },
    updateProgressTime(e, i) {
      this.$confirm('是否需要更新该物流状态时间为' + e + '?', '检测到时间变动', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$fetch.post('Order/updateExpressProgressTime', {
          id: i,
          time: e
        }, true).then(res => {
          this.$message({
            message: '该状态时间变更成功',
            type: 'success'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消更新'
        });
        this.progressShow = false
      });

    },
    pageChange(e) {
      this.page = e
      this.checkList = []
      this.getOrders()
    },
    noUpdate() {
      console.log('不更新')

    },
    searchOrder(e) {
      if (!e) {
        this.$message({
          type: 'info',
          message: '当前没有搜索任何信息'
        });
        return false
      }
      this.searchValue = e
      this.page = 1
      this.getOrders()
      console.log(e)
    },
    clearSearch() {
      console.log('清空搜索')
      this.searchValue = ''
      this.page = 1
      this.getOrders()
    },
    openRemark(id, old) {
      this.$prompt('请输入系统备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: old,
        inputType: 'textarea'
      }).then(({value}) => {
        this.updateSysRemark(id, value)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    updateSysRemark(id, value) {
      this.$fetch.post('Order/updateSysRemark', {
        id: id,
        value: value
      }, true).then(res => {
        this.getOrders()
      })
    },
    transDeliver(id) {
      this.transDeliverShow = true
      this.transDeliverId = id
      this.transDeliverNo = ''
      this.transDeliverNote = ''
    },
    sendHome(id, uid) {
      this.$confirm('此操作不可逆转, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$fetch.post('Order/sendHome', {
          id: id,
          owner: uid
        }, true).then(res => {
          this.getOrders()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    selfPick(id, uid) {
      this.$confirm('此操作不可逆转, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$fetch.post('Order/selfPickup', {
          id: id,
          owner: uid
        }, true).then(res => {
          this.getOrders()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    signExpress(id, uid) {
      this.$confirm('此操作不可逆转, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$fetch.post('Order/signExpress', {
          id: id,
          owner: uid
        }, true).then(res => {
          this.getOrders()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    signGroup(id, uid) {
      this.$confirm('此操作不可逆转, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$fetch.post('Order/signGroup', {
          id: id,
          owner: uid
        }, true).then(res => {
          this.getOrders()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    confirmTransDeliver() {
      this.$fetch.post('Order/transDeliver', {
        id: this.transDeliverId,
        express: this.transDeliverNo,
        note: this.transDeliverNote
      }, true).then(res => {
        this.transDeliverShow = false
        this.transDeliverId = ''
        this.transDeliverNo = ''
        this.transDeliverNote = ''
        this.getOrders()
      })
    },
    singlePrint(id) {
      window.open("/#/print/index?id=" + id)
    },
    groupPrintData(u, gid, oid) {
      window.open("/#/print/group?u=" + u + '&gid=' + gid + '&oid=' + oid)
    },
    groupPrint(id) {
      this.$fetch.post('Order/getOrderGroupUser', {
        id
      }, true).then(res => {
        this.groupShow = true
        this.groupMember = res.member
        this.groupId = res.groupId
        this.groupOrder = res.groupOrder
      })
    }
  }
}
</script>

<style scoped>
.this-page {
  padding: 10px;
  background-color: #FFFFFF;

}
</style>
